import type { Parameter, ParameterValue, SystemParameter } from "building-types/options/parameter";
import type { Table } from "common/data/table";
import objectFilter from "common/utils/objectFilter";
import objectMap from "common/utils/objectMap";
import { SystemParameters } from "./systemParameters";

export function parameterFormatName(name: string, addNumericExtensionIfSystem = true) {
  // replace all non-alphanumeric characters with empty string
  const n = name.replace(/[^a-zA-Z_0-9]/g, "");

  // if the name is a system parameter, add a numeric extension
  if (
    addNumericExtensionIfSystem &&
    (Object.values(SystemParameters) as SystemParameter[]).find((x) => x.name === n) !== undefined
  ) {
    return `${n}1`;
  }

  return n;
}

export function evaluateParameterDefaultValues(params: Table<Parameter>): Table<ParameterValue> {
  return objectFilter(
    objectMap(params, (param) => param.defaultValue),
    (v) => v !== undefined,
  ) as Table<ParameterValue>;
}
